import { stableStringify } from "@/utils/stable-stringify"
import { md5 } from "super-fast-md5"
import { xxhash3 } from "hash-wasm"

const textEncoder = new TextEncoder()

export function hashData(data: Uint8Array) {
	return md5(data)
}

export function hashString(data: string) {
	return hashData(textEncoder.encode(data))
}

export function hashObject(obj: Record<string, any>) {
	// JSON.stringify can return keys is different order depending on when and how they were inserted into the object
	// stableStringify solves this issue by sorting keys before serialization
	return hashString(stableStringify(obj))
}

export const hashFileContent = async (xmpContentBlob: Blob) => {
	const contentArrayBuffer = await xmpContentBlob.arrayBuffer()
	const contentUint8Array = new Uint8Array(contentArrayBuffer)

	return hashData(contentUint8Array)
}

export const hashJSONAdjustments = async (jsonContentBlob: Blob) => {
	const presetContentText = await jsonContentBlob.text()
	const content = JSON.parse(presetContentText)

	return hashObject(content)
}

// Using faster xxhash3, only used for color match images for now, will migrate the rest later
export const fastHashData = async (data: Uint8Array) => {
	const hash = await xxhash3(data)
	return hash.toString()
}

export const fastHashFileContent = async (xmpContentBlob: Blob) => {
	const contentArrayBuffer = await xmpContentBlob.arrayBuffer()
	const contentUint8Array = new Uint8Array(contentArrayBuffer)

	return fastHashData(contentUint8Array)
}
